import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import Accordion from "../../../common/accordion";
import { LABELS } from "../../../../constants/labels/help.labels";


const GasCalculations: React.FC = () => {
    const {
        gasFormulasCollapse,
        gasHandlersCollapse,
        gasChargePumpCollapse } = useAppSelector(
            (state) => state?.collapse
        );

    const { updateGasFormulasCollapse,
        updateGasHandlersCollapse,
        updateGasChargePumpCollapse } =
        useCollapseFacade();

    const handleCollapseChange = (key: boolean, name: string) => {
        if (name === "gas-formulas") updateGasFormulasCollapse(key);
        else if (name === "wapperGasHandlers") updateGasHandlersCollapse(key);
        else if (name === "wapperChargePump") updateGasChargePumpCollapse(key)
    };

    return (
        <>
            <div className="flex flex-col justify-center item-center w-full h-full gap-[16px]">
                <Accordion
                    title={LABELS?.gasHandler}
                    id={'wapperGasHandlers'}
                    isOpen={!gasHandlersCollapse}
                    onToggle={() => handleCollapseChange(!gasHandlersCollapse, "wapperGasHandlers")}
                    content={
                        <div className="flex justify-center items-center p-4 gap-4 w-full text-white bg-darkcolor-800 rounded-br-lg rounded-bl-lg">
                            <div className="pad-all bg-darkcolor-700 border-[1px] rounded-[8px] border-darkcolor-400">
                                <table className="min-w-full table-fixed over">
                                    <colgroup>
                                        <col style={{ width: "10%" }} />
                                        <col style={{ width: "40%", borderRight: "1px solid #4a5463" }} />
                                        <col style={{ width: "10%" }} />
                                        <col style={{ width: "40%" }} />
                                    </colgroup>
                                    <tr className="align-center border-b-[1px] border-darkcolor-400 text-[14px] font-normal">
                                        <th className="align-center px-[24px] py-[16px] font-normal whitespace-nowrap text-[14px] font-normal">No. of stages</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div className="flex flex-wrap secondary">
                                                Selected GKX pump(NoOfStages) from ESP catalog (Dr_GKXPumps table in
                                                database)
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal whitespace-nowrap text-[14px] font-normal">Target flow rate</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div className="secondary pb-4"> TotalFluidVolume from gas output calculations
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">If gas separator is selected then:</p>
                                                <p className="secondary-text">Select right most TotalFluidVolume of gas separator</p>
                                            </div>
                                            <div className="">
                                                <p className="secondary">Otherwise:</p>
                                                <p className="secondary-text">
                                                    Select intake TotalFluidVolume
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="align-center border-b-[1px] border-darkcolor-400">
                                        <th className="col-1 align-center px-[24px] py-[16px] whitespace-nowrap text-[14px] font-normal">Lift/Stage</th>
                                        <td className="align-center px-[24px] py-[16px] text-[14px] font-normal">
                                            <div className="pb-4 secondary">
                                                Lift * headCorrectionFactor * (speedAtFrequency / 3500)^ 2;
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">speedAtFrequency:</p>
                                                <p className="secondary-text">
                                                    operatingFrequency * speed / 60;
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">Lift:</p>
                                                <p className="secondary-text">
                                                    H0 + (H1 * ProductionCapacity) + (H2 * ProductionCapacity ^ 2) + (H3 *
                                                    ProductionCapacity ^ 3) + (H4 *
                                                    ProductionCapacity ^ 4) + (H5 * ProductionCapacity ^ 5)
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">ProductionCapacity:</p>
                                                <p className="secondary-text">
                                                    productionRate / flowCorrectionFactor * 3500 / speedAtFrequency;
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">speedAtFrequency:</p>
                                                <p className="secondary-text">
                                                    operatingFrequency * speed / 60;
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">productionRate:</p>
                                                <p className="secondary-text">
                                                    Intake TotalFluidVolume
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">headCorrectionFactor:</p>
                                                <p className="secondary-text">
                                                    Head correction factor from gas output calculations
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">flowCorrectionFactor:</p>
                                                <p className="secondary-text">
                                                    Flow correction factor from gas output calculations
                                                </p>
                                            </div>
                                            <div className="align-center">
                                                <p className="secondary">Speed:</p>
                                                <p className="secondary-text">
                                                    Motor full load speed @ 60 Hz pump output tab
                                                </p>
                                            </div>
                                        </td>
                                        <th className="col-1 align-center px-[24px] py-[16px] whitespace-nowrap text-[14px] font-normal">Final TDH</th>
                                        <td className="align-center px-[24px] py-[16px] text-[14px] font-normal">
                                            <div className="pb-4 secondary">
                                                (LiftPerStage * NoOfStages * 2.31) / CompositeSpGr;
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">CompositeSpGr:</p>
                                                <p className="secondary-text">
                                                    Composite SpGr from gas output calculations
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">If gas separator is selected then:</p>
                                                <p className="secondary-text">
                                                    Select right most composite SpGr of gas separator
                                                </p>
                                            </div>
                                            <div className="align-center">
                                                <p className="secondary">Otherwise:</p>
                                                <p className="secondary-text">
                                                    Select intake composite SpGr
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="align-center border-b-[1px] border-darkcolor-400">
                                        <th className="col-1 align-center px-[24px] py-[16px] whitespace-nowrap text-[14px] font-normal">Total power</th>
                                        <td className="align-center px-[24px] py-[16px] text-[14px] font-normal">
                                            <div className="pb-4 secondary">
                                                desiredStages * finaltargetBHP;
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">finaltargetBHP:</p>
                                                <p className="secondary-text">
                                                    targetBHP * powercorrectionfactor * (speedAtFrequency / 3500)^3;
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">speedAtFrequency:</p>
                                                <p className="secondary-text">
                                                    speed * operatingFrequency / 60
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">targetBHP:</p>
                                                <p className="secondary-text">
                                                    B0 + (B1 * ProductionCapacity) + (B2 * ProductionCapacity ^ 2) + (B3 *
                                                    ProductionCapacity ^ 3) + (B4 *
                                                    ProductionCapacity ^ 4) + (B5 * ProductionCapacity ^ 5)
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">ProductionCapacity:</p>
                                                <p className="secondary-text">
                                                    productionRate / flowCorrectionFactor * 3500 / speedAtFrequency;
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">productionRate:</p>
                                                <p className="secondary-text">
                                                    Intake TotalFluidVolume
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">powercorrectionfactor:</p>
                                                <p className="secondary-text">
                                                    Power correction factor from gas output calculations
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">flowCorrectionFactor:</p>
                                                <p className="secondary-text">
                                                    Flow correction factor from gas output calculations
                                                </p>
                                            </div>
                                            <div className="align-center">
                                                <p className="secondary">Speed:</p>
                                                <p className="secondary-text">
                                                    Motor full load speed @ 60 Hz pump output tab
                                                </p>
                                            </div>
                                        </td>
                                        <th className="col-1 align-center px-[24px] py-[16px] whitespace-nowrap text-[14px] font-normal">Efficiency</th>
                                        <td className="align-center px-[24px] py-[16px] text-[14px] font-normal">
                                            <div className="pb-4 secondary">
                                                convertTFV * LiftPerStage / (totalPower / desiredStages) / 135773 * 100;
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">convertTFV:</p>
                                                <p className="secondary-text">
                                                    TotalFluidVolume from gas output calculations
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">If gas separator is selected then:</p>
                                                <p className="secondary-text">
                                                    Select right most TotalFluidVolume of gas separator
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">Otherwise:</p>
                                                <p className="secondary-text">
                                                    Select intake TotalFluidVolume
                                                </p>
                                            </div>
                                            <div className="align-center">
                                                <p className="secondary">LiftPerStage,desiredStages,totalPower:</p>
                                                <p className="secondary-text">
                                                    From gas handler section in output tab
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="align-center">
                                        <th className="col-1 align-center px-[24px] py-[16px] whitespace-nowrap text-[14px] font-normal">Shaft load</th>
                                        <td className="align-center px-[24px] py-[16px] text-[14px] font-normal">
                                            <div className="pb-4 secondary">
                                                (PowerGasHandler + PowerChargePump1 + PowerChargePump2 + PowerChargePump3 +
                                                PowerMainPump) / shaftRating;
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">shaftRating:</p>
                                                <p className="secondary-text">
                                                    (shaftLimit * OperatingFrequency) / 60;
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">If shaft type is standard then shaftLimit:</p>
                                                <p className="secondary-text">
                                                    Selected StdShaft from ESP catalog (Dr_GKXPumps table in
                                                    database)
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">If shaft type is high strength then shaftLimit:</p>
                                                <p className="secondary-text">
                                                    Selected HsShaft from ESP catalog (Dr_GKXPumps table in
                                                    database)
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">PowerGasHandler:</p>
                                                <p className="secondary-text">
                                                    Power @ Design frequency from gas handler section
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">PowerChargePump1,PowerChargePump2,PowerChargePump3:</p>
                                                <p className="secondary-text">
                                                    Power @ Design frequency from charge pump section
                                                </p>
                                            </div>
                                            <div className="align-center">
                                                <p className="secondary">PowerMainPump:</p>
                                                <p className="secondary-text">
                                                    Power @ Design frequency from pump output tab
                                                </p>
                                            </div>
                                        </td>
                                        <th className="col-1 align-center px-[24px] py-[16px]"></th>
                                        <td className="align-center px-[24px] py-[16px]"></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    }
                />
                <Accordion
                    id={'wapperChargePump'}
                    title={LABELS?.chargePump}
                    isOpen={!gasChargePumpCollapse}
                    onToggle={() =>
                        handleCollapseChange(!gasChargePumpCollapse, "wapperChargePump")
                    }
                    content={
                        <div className="flex flex-wrap w-full gap-4 p-4 text-white bg-darkcolor-800 rounded-br-lg rounded-bl-lg">
                            <div className="align-center pad-all text-white bg-darkcolor-700 border-[1px] rounded-[8px] border-darkcolor-400">
                                <table className="align-center table table-striped table-bordered dtr-inline">
                                    <colgroup>
                                        <col style={{ width: "10%" }} />
                                        <col style={{ width: "40%", borderRight: "1px solid #4a5463" }} />
                                        <col style={{ width: "10%" }} />
                                        <col style={{ width: "40%" }} />
                                    </colgroup>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal whitespace-nowrap text-[14px] font-normal text-[14px] font-normal">Target flow rate</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div className="pb-4 secondary">TotalFluidVolume from gas output calculations
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">If charge pump selected is more than one then:</p>
                                                <p className="align-center secondary-text">
                                                    Select TotalFluidVolume of previous charge pump
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">ELSE If gas separator is selected then:</p>
                                                <p className="align-center secondary-text">
                                                    Select right most TotalFluidVolume of gas separator
                                                </p>
                                            </div>
                                            <div className="align-center">
                                                <p className="secondary">Otherwise:</p>
                                                <p className="align-center secondary-text">
                                                    Select intake TotalFluidVolume
                                                </p>
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal whitespace-nowrap text-[14px] font-normal text-[14px] font-normal">Lift/Stage</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div className="pb-4 secondary">
                                                Lift * headCorrectionFactor * (speedAtFrequency / 3500)^ 2;
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">speedAtFrequency:</p>
                                                <p className="align-center secondary-text">
                                                    operatingFrequency * speed / 60;
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">Lift:</p>
                                                <p className="align-center secondary-text">
                                                    H0 + (H1 * ProductionCapacity) + (H2 * ProductionCapacity ^ 2) + (H3 *
                                                    ProductionCapacity ^ 3) + (H4 *
                                                    ProductionCapacity ^ 4) + (H5 * ProductionCapacity ^ 5)
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">ProductionCapacity:</p>
                                                <p className="align-center secondary-text">
                                                    productionRate / flowCorrectionFactor * 3500 / speedAtFrequency;
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">speedAtFrequency:</p>
                                                <p className="align-center secondary-text">
                                                    operatingFrequency * speed / 60;
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">productionRate:</p>
                                                <p className="align-center secondary-text">
                                                    Intake TotalFluidVolume
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">headCorrectionFactor:</p>
                                                <p className="align-center secondary-text">
                                                    Head correction factor from gas output calculations
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">flowCorrectionFactor:</p>
                                                <p className="align-center secondary-text">
                                                    Flow correction factor from gas output calculations
                                                </p>
                                            </div>
                                            <div className="align-center">
                                                <p className="secondary">Speed:</p>
                                                <p className="align-center secondary-text">
                                                    Motor full load speed @ 60 Hz pump output tab
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal whitespace-nowrap text-[14px] font-normal">Final TDH</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div className="pb-4 secondary">
                                                (LiftPerStage * NoOfStages * 2.31) / CompositeSpGr;
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">CompositeSpGr:</p>
                                                <p className="align-center secondary-text">
                                                    Composite SpGr from gas output calculations
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">If charge pump selected is more than one then:</p>
                                                <p className="align-center secondary-text">
                                                    Select composite SpGr of previous charge pump
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">If gas separator is selected then:</p>
                                                <p className="align-center secondary-text">
                                                    Select right most composite SpGr of gas separator
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">Otherwise:</p>
                                                <p className="align-center secondary-text">
                                                    Select intake composite SpGr
                                                </p>
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal whitespace-nowrap text-[14px] font-normal">Total power</th>
                                        <td className="align-center px-[24px] py-[16px] col-2">
                                            <div className="pb-4 secondary">
                                                desiredStages * finaltargetBHP;
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">finaltargetBHP:</p>
                                                <p className="align-center secondary-text">
                                                    targetBHP * powercorrectionfactor * (speedAtFrequency / 3500)^3;
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">speedAtFrequency:</p>
                                                <p className="align-center secondary-text">
                                                    speed * operatingFrequency / 60
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">targetBHP:</p>
                                                <p className="align-center secondary-text">
                                                    B0 + (B1 * ProductionCapacity) + (B2 * ProductionCapacity ^ 2) + (B3 *
                                                    ProductionCapacity ^ 3) + (B4 *
                                                    ProductionCapacity ^ 4) + (B5 * ProductionCapacity ^ 5)
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">ProductionCapacity:</p>
                                                <p className="align-center secondary-text">
                                                    productionRate / flowCorrectionFactor * 3500 / speedAtFrequency;
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">productionRate:</p>
                                                <p className="align-center secondary-text">
                                                    Intake TotalFluidVolume
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">powercorrectionfactor:</p>
                                                <p className="align-center secondary-text">
                                                    Power correction factor from gas output calculations
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">flowCorrectionFactor:</p>
                                                <p className="align-center secondary-text">
                                                    Flow correction factor from gas output calculations
                                                </p>
                                            </div>
                                            <div className="align-center">
                                                <p className="secondary">Speed:</p>
                                                <p className="align-center secondary-text">
                                                    Motor full load speed @ 60 Hz pump output tab
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="align-center px-[24px] py-[16px] font-normal whitespace-nowrap text-[14px] font-normal">Efficiency</th>
                                        <td className="align-center px-[24px] py-[16px] col-2">
                                            <div className="pb-4 secondary">
                                                convertTFV * LiftPerStage / (totalPower / desiredStages) / 135773 * 100;
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">convertTFV:</p>
                                                <p className="align-center secondary-text">
                                                    TotalFluidVolume from gas output calculations
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">If charge pump selected is more than one then:</p>
                                                <p className="align-center secondary-text">
                                                    Select TotalFluidVolume of previous charge pump
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">If gas separator is selected then:</p>
                                                <p className="align-center secondary-text">
                                                    Select right most TotalFluidVolume of gas separator
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">Otherwise:</p>
                                                <p className="align-center secondary-text">
                                                    Select intake TotalFluidVolume
                                                </p>
                                            </div>
                                            <div className="align-center">
                                                <p className="secondary">LiftPerStage, desiredStages, totalPower:</p>
                                                <p className="align-center secondary-text">
                                                    From gas handler section in output tab
                                                </p>
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal whitespace-nowrap text-[14px] font-normal">Shaft load</th>
                                        <td className="align-center px-[24px] py-[16px] col-2">
                                            <div className="pb-4 secondary">
                                                (PowerGasHandler + PowerChargePump1 + PowerChargePump2 + PowerChargePump3 +
                                                PowerMainPump) / shaftRating;
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">shaftRating:</p>
                                                <p className="align-center secondary-text">
                                                    (shaftLimit * OperatingFrequency) / 60;
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">If shaft type is standard then shaftLimit:</p>
                                                <p className="align-center secondary-text">
                                                    Selected StdShaft from ESP catalog (Dr_Pumps table in
                                                    database)
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">If shaft type is high strength then shaftLimit:</p>
                                                <p className="align-center secondary-text">
                                                    Selected HsShaft from ESP catalog (Dr_GKXPumps table in
                                                    database)
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">PowerGasHandler:</p>
                                                <p className="align-center secondary-text">
                                                    Power @ Design frequency from gas handler section
                                                </p>
                                            </div>
                                            <div className="align-center pb-4">
                                                <p className="secondary">PowerChargePump1, PowerChargePump2, PowerChargePump3:</p>
                                                <p className="align-center secondary-text">
                                                    Power @ Design frequency from charge pump section
                                                </p>
                                            </div>
                                            <div className="align-center">
                                                <p className="secondary">PowerMainPump:</p>
                                                <p className="align-center secondary-text">
                                                    Power @ Design frequency from pump output tab
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    }
                />
                <Accordion
                    title={LABELS?.formulas}
                    id={'gas-formulas'}
                    isOpen={!gasFormulasCollapse}
                    onToggle={() =>
                        handleCollapseChange(!gasFormulasCollapse, "gas-formulas")
                    }
                    content={
                        <div className="flex flex-wrap w-full gap-4 p-4 text-white bg-darkcolor-800 rounded-br-lg rounded-bl-lg">
                            <div className="w-full bg-darkcolor-700 border-[1px] rounded-lg border-darkcolor-400 p-[24px]">
                                <div className="text-[16px] font-normal text-neutral-25 grid grid-cols-[120px_10px_1fr] gap-x-4">
                                    <span>BPp</span>
                                    <span>:</span>
                                    <span>Bubble point pressure</span>
                                    <span>BHT</span>
                                    <span>:</span>
                                    <span>Bottom hole temperature</span>
                                    <span>TVF</span>
                                    <span>:</span>
                                    <span>Pump setting vertical depth</span>
                                    <span>Pc</span>
                                    <span>:</span>
                                    <span>Casing pressure</span>
                                    <span>GasComp</span>
                                    <span>:</span>
                                    <span>Gas compressibility</span>
                                    <span>SpGr_Gas</span>
                                    <span>:</span>
                                    <span>Specific gravity of gas</span>
                                    <span>SpGr_Oil</span>
                                    <span>:</span>
                                    <span>Specific gravity of oil</span>
                                    <span>SpGr_Water</span>
                                    <span>:</span>
                                    <span>Specific gravity of water</span>
                                    <span>Composite_SpGr</span>
                                    <span>:</span>
                                    <span>Composite specific gravity</span>
                                </div>
                            </div>
                            <div className="align-center pad-all bg-darkcolor-700 border-[1px] rounded-[8px] border-darkcolor-400">
                                <table className="table-auto w-full border-collapse">
                                    <colgroup>
                                        <col style={{ width: "10%" }} />
                                        <col style={{ width: "40%", borderRight: "1px solid #4a5463" }} />
                                        <col style={{ width: "10%" }} />
                                        <col style={{ width: "40%" }} />
                                    </colgroup>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-[14px] font-normal">
                                        <th className="align-center px-[24px] py-[16px] font-normal font-normal">PWF</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <p className="secondary">
                                                Max speed of motor, if specified on motor or else 3500
                                            </p>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal font-normal">PSIContribution</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <p className="secondary">
                                                HeadPerStage_Of_GKX_Pump * Composite_SpGr / 2.31
                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-[14px] font-normal">
                                        <th className="align-center px-[24px] py-[16px] font-normal font-normal">PIP</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, GKX pump selected</b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    PIP + PSIContribution
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    (Flop * Composite_SpGr / 2.31) + Pc;
                                                </p>
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal font-normal">SpHeatOil</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <p className="secondary">
                                                0.000458 * BHT + 0.4025
                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal font-normal">CompositeSpHeat</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <p className="secondary">
                                                WaterCut / 100 + (100 - WaterCut) / 100 * SpHeatOil
                                            </p>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal font-normal">TempRise</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, GKX pump selected</b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    HeadPerStage_Of_GKX_Pump / 778 *
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    0
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal font-normal">BHT</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, GKX pump selected</b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    BHT (from input fluid tab) + TempRise
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    BHT (from input fluid tab)
                                                </p>
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal font-normal">Ppc</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <p className="secondary">
                                                709.6 - 58.7 * SpGr_Gas
                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal font-normal">Ppr</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <p className="secondary">
                                                PIP / Ppc
                                            </p>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal font-normal">Tpc</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <p className="secondary">
                                                170.5 + 307.3 * SpGr_Gas
                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal font-normal">Tpr</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <p className="secondary">
                                                (BHT + 460) / Tpc
                                            </p>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal font-normal">GasComp</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, gas availability selected</b>
                                                </p>
                                                <p className="pl-2">
                                                    <b>If, GasCompressibility &gt; 0</b>
                                                </p>
                                                <p className="pl-4">
                                                    GasCompressibility (from inputs)
                                                </p>
                                                <p className="pl-2">
                                                    <b>Else</b>
                                                </p>
                                                <p className="pl-4">
                                                    1 - ((3.52 * Ppr) / 10 ^ (0.918 * Tpr) + 0.274 * Ppr ^ 2 / 10 ^ (0.8157 *
                                                    Tpr))
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="pl-2">
                                                    0
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal font-normal">PressureCalc</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, gas availability selected</b>
                                                </p>
                                                <p className="pl-2">
                                                    <b>if, PIP &gt; BPp</b>
                                                </p>
                                                <p className="pl-4">
                                                    BPp (from inputs)
                                                </p>
                                                <p className="pl-2">
                                                    <b>Else</b>
                                                </p>
                                                <p className="pl-4">
                                                    PIP_Computed
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="pl-2">
                                                    0
                                                </p>
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal font-normal">Rs</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="p-2 secondary">
                                                    <b>if, gas availability selected and BOPD &gt; 0</b>
                                                </p>
                                                <p className="align-center p-2 secondary-text">
                                                    SpGr_Gas * (PressureCalc / 18 * 10 ^ (0.0125 * Oil_Api) / 10 ^ (0.00091 *
                                                    BHT)) ^ 1.2408
                                                </p>
                                                <p className="p-2 secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p>
                                                    0
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal font-normal">F</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, gas availability selected</b>
                                                </p>
                                                <p className="pl-2">
                                                    <b>if, BOPD = 0</b>
                                                </p>
                                                <p className="pl-4">
                                                    1.25 * BHT
                                                </p>
                                                <p className="pl-2">
                                                    <b>Else</b>
                                                </p>
                                                <p className="pl-4">
                                                    Rs * (SpGr_Gas / SpGr_Oil) ^ 0.5 + 1.25 * BHT
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="pl-2">
                                                    0
                                                </p>
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal">Bg</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, gas availability selected</b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    5.04 * (GasComp * (BHT + 460)) / (PIP + 14.7)
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    1
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal">Bo</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, gas availability selected</b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    0.972 + 1.47 * 10 ^ -4 * F ^ 1.175
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    1
                                                </p>
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal">WOR</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, BOPD &gt; 0</b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    BWPD / BOPD
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    0
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal">PL</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, BOPD = 0</b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    62.4 * SpGr_Water
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    62.4 * (SpGr_Oil / Bo * (1 / (1 + WOR)) + SpGr_Water / 1 * (WOR / (1 +
                                                    WOR)))
                                                </p>
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal">A</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, gas availability selected</b>
                                                </p>
                                                <p className="pl-2">
                                                    <b>if, natural seperation is exist</b>
                                                </p>
                                                <p className="pl-4">
                                                    0.0055 * CasingId ^ 2 - TubingOD ^ 2
                                                </p>
                                                <p className="pl-2">
                                                    <b>Else if, gas design is standard seperation</b>
                                                </p>
                                                <p className="pl-4">
                                                    0.0055 * AnchorId ^ 2 - AnchorTubingOD ^ 2
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="pl-2">
                                                    0
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal">Vsl</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, BOPD = 0</b>
                                                </p>
                                                <p className="pl-2">
                                                    605 * 10 ^ -5 * (ProductionRate / A)
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="pl-2">
                                                    605 * 10 ^ -5 * (ProductionRate / A) * (Bo / (1 + WOR) + (WOR / (1 + WOR)))
                                                </p>
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal">Pg</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <p className="secondary">
                                                0.0764 * SpGr_Gas / (Bg * 5.61 / 1000)
                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal">Vb</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <p className="secondary">
                                                2 ^ (1/2) * (0.04 * 32 * (PL - Pg) / PL ^ 2) ^ (1/4)
                                            </p>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal">FreeGasVolRate</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, BOPD = 0</b>
                                                </p>
                                                <p className="pl-2">
                                                    Gas_Production
                                                </p>
                                                <p className="secondary">
                                                    <b>Else if, GOR &gt; Rs</b>
                                                </p>
                                                <p className="pl-2">
                                                    BOPD * (GOR - Rs) / 1000
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="pl-2">
                                                    0
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal">Vg</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, natual seperation exist</b>
                                                </p>
                                                <p className="pl-2">
                                                    FreeGasVolRate * Bg
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="pl-2">
                                                    FreeGasVolRate * Bg * (1 - Efficiency_Comp)
                                                </p>
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal">GasVolume</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, seperators selected</b>
                                                </p>
                                                <p className="pl-2">
                                                    Vg * (1 - Gas_Seperator_Effciency / 100)
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="pl-2">
                                                    Vg
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal">Vo</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <p className="secondary">
                                                BOPD * Bo
                                            </p>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal">Vw</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <p className="secondary">
                                                BWPD
                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal">Vt</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <p className="secondary">
                                                GasVolume + Vo + Vw
                                            </p>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal">Efficiency</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, charge pump selected</b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    Vt * HeadPerStage_Of_Charge_Pump * NoOfStage_Of_Charge_Pump / HP_Of_GKX_Pump
                                                    / 135773
                                                </p>
                                                <p className="secondary">
                                                    <b>Else if, GKX Pump selected</b>
                                                </p>
                                                <p className="pl-2">
                                                    Vt * HeadPerStage_Of_GKX_Pump * NoOfStage_Of_GKX_Pump / HP_Of_GKX_Pump /
                                                    135773
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="pl-2">
                                                    Vb / (Vb / Vsl)
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal">GOR</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>if, BOPD &gt; 0</b>
                                                </p>
                                                <p className="pl-2">
                                                    ((1000 * GasVolume / Bg) + Rs * BOPD) / BOPD
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="pl-2">
                                                    0
                                                </p>
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal">GLR</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <p className="secondary">
                                                ((1000 * GasVolume / Bg) + Rs * BOPD) / ProductionRate
                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal">FreeGas</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <p className="secondary">
                                                GasVolume / Vt
                                            </p>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal">AnchorSepEff</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <p className="secondary">
                                                    <b>If, gas design is standard seperation</b>
                                                </p>
                                                <p className="pl-2">
                                                    Efficiency
                                                </p>
                                                <p className="secondary">
                                                    <b>Else</b>
                                                </p>
                                                <p className="pl-2">
                                                    0
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal">Final_Composite_SpGr</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div className="align-center">
                                                <p className="secondary">
                                                    TMPF /(BFPD * 62.4 * 5.6146)
                                                </p>
                                                <p>
                                                    TMPF = [(BOPD * SpGr_Oil + BWPD * SpGr_Water) * 62.4 * 5.6146] + (GOR * BOPD
                                                    *
                                                    SpGr_Gas)
                                                </p>
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal">Flop</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <p className="secondary">
                                                (PIP - casingPressure) * 2.31 / Final_Composite_SpGr
                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal">Flow factor (%)</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                FlowCorrectionFactor = capacityCalc;
                                                <p><b>if (viscosity is greater than MaxViscosity)</b></p>
                                                <p className="pl-2">
                                                    capacityCalc =VQ1 + VQ2 * MaxViscosity + VQ3 * (MaxViscosity^2) + VQ4 *
                                                    (MaxViscosity^3);
                                                    (MaxViscosity^3);
                                                </p>
                                                <p><b> Else</b></p>
                                                <p className="pl-2">capacityCalc = VQ1 + VQ2 * viscosity + VQ3 * (viscosity^2) + VQ4
                                                    * (viscosity^3);</p>
                                            </div>
                                            <div className="align-center">
                                                <p className="secondary"><b>If (viscosity is Less than MinViscosity)
                                                </b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    capacityCalc = 1;
                                                </p>
                                                <p className="econdary"><b>if (capacityCalc is greater than 1)
                                                </b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    FlowCorrectionFactor = 1;
                                                </p>
                                                <p className="secondary">
                                                    <b>
                                                        else if (capacityCalc &lt;= 1 & capacityCalc &gt; 0)
                                                    </b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    FlowCorrectionFactor = capacityCalc;
                                                </p>
                                                <p className="secondary">
                                                    <b>
                                                        else
                                                    </b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    FlowCorrectionFactor = 1;
                                                </p>
                                                <p className="secondary">
                                                    VQ1,VQ2,VQ3,VQ4,MinViscosity,MaxViscosity
                                                </p>
                                                <p className="secondary">
                                                    <b>ESPCatalog (DR_Pumps) in database</b>
                                                </p>
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal">Head factor (%)</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                HeadCorrectionFactor = headCalc;
                                                <p><b>If (viscosity is greater than MaxViscosity)</b></p>
                                                <p className="pl-2">
                                                    headCalc = VH1 +VH2 * MaxViscosity + VH3 * (MaxViscosity^2) + VH4 *
                                                    (MaxViscosity^3);
                                                </p>
                                                <b> Else</b>
                                                <p className="pl-2">headCalc = VH1 + VH2 * viscosity + VH3 * (viscosity^2) + VH4 *
                                                    (viscosity^3);</p>
                                            </div>
                                            <div className="align-center">
                                                <p className="secondary"><b>If (viscosity is less than MinViscosity)</b></p>
                                                <p className="align-center pl-2 secondary-text">
                                                    headCalc = 1
                                                </p>
                                                <p className="secondary"><b>If (headCalc is greater than 1)</b></p>
                                                <p className="align-center pl-2 secondary-text">
                                                    HeadCorrectionFactor = 1;
                                                </p>
                                                <p className="secondary">
                                                    <b>
                                                        else if (headCalc greater than 0 & headCalc Less than or Equal to 1)
                                                    </b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    HeadCorrectionFactor = headCalc;
                                                </p>
                                                <p className="secondary">
                                                    <b>
                                                        else
                                                    </b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    HeadCorrectionFactor = 1;
                                                </p>
                                                <p className="secondary">
                                                    VH1,VH2,VH3,VH4,MinViscosity,MaxViscosity
                                                </p>
                                                <p className="secondary">
                                                    <b>ESPCatalog (DR_Pumps) in database</b>
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400">
                                        <th className="align-center px-[24px] py-[16px] font-normal">Liquid phase composite SpGr</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <strong>
                                                    Fo * SpGrOil + Fw * SpGrWater
                                                </strong>
                                                <p>Fw = 1 - Fo</p>
                                                <p>
                                                    Fo = Vo / (Vo + Vw);
                                                </p>
                                                <p>
                                                    Vo = BOPD * Bo<br />Vw = BWPD
                                                </p>
                                                <strong>If selected region is United States (Permian Basin)</strong>
                                                <p className="pl-2">
                                                    If BOPD is equal to 0 <br />
                                                    Rs = 0<br />
                                                    F = 1.25 * BottomHoleTemp<br />
                                                    Bo = 0.972 + 1.47 * 10<sup>-4</sup> * F<sup>1.175</sup><br /><br />
                                                    <strong>Else</strong><br />
                                                    Rs = SpGrGas * ((Pressure / 18) * (10<sup>0.0125 * OilAPI</sup> / 10<sup>0.00091 * BottomHoleTemp</sup>))<sup>1.2048</sup><br />
                                                    F = Rs * (SpGrGas / SpGrOil)<sup>0.5</sup> + 1.25 * BottomHoleTemp<br />
                                                    Bo = 0.972 + 1.47 * 10<sup>-4</sup> * F<sup>1.175</sup>
                                                </p>
                                                <br />
                                                <strong>Else If selected region is South America</strong>
                                                <p className="pl-2">
                                                    if (oilApi &lt;= 20.5) <br />
                                                    Rs = (Pressure - 358.05) * (oilApi<sup>-4.78945</sup> * 1.58235 * (BottomHoleTemp + 460)<sup>0.83998</sup>) * 678.3<br />
                                                    else if (oilApi &gt; 20.5)<br />
                                                    if (PIP &gt; BPPressure)<br />
                                                    c = BPPressure + 652.044 + 518.6 * (Log10(oilApi) / 0.43429)<br />
                                                    else if (PIP &lt;= convertBPPressure)<br />
                                                    c = Pressure + 652.044 + 518.6 * (Log10(oilApi) / 0.43429)<br />
                                                    D = 518.6 - (4353.15 / oilApi)<br />
                                                    E = Log10(BottomHoleTemp) / 0.43429<br />
                                                    K = (c / D) - E<br />
                                                    Rs = Exp(K)<br />
                                                    if (PIP &gt; convertBPPressure)<br />
                                                    Bo = 0.943775 + 0.000510223 * BottomHoleTemp + 0.000052481 * BPPressure - 0.0000449966 * Rs + 0.000581246 * oilApi<br />
                                                    else if (PIP &lt;= convertBPPressure)<br />
                                                    K = Math.Pow(Rs, 0.0395629) * Math.Pow(oilApi, -0.205569)<br />
                                                    Bo = -3.89137 + 0.00714052 * (BottomHoleTemp + 460) + 5.84787 * K - 6.93458 * K<sup>2</sup>
                                                </p>
                                                <br />
                                                <strong>Else If selected region is South America</strong>
                                                <p className="pl-2">
                                                    a1 = 4.86996E-06<br />
                                                    a2 = 5.730982539<br />
                                                    a3 = 9.92510E-03<br />
                                                    a4 = 1.776179364<br />
                                                    a5 = 44.25002680<br />
                                                    a6 = 2.702889206<br />
                                                    a7 = 0.744335673<br />
                                                    a8 = 3.359754970<br />
                                                    a9 = 28.10133245<br />
                                                    a10 = 1.579050160<br />
                                                    a11 = 0.928131344<br /><br />
                                                    if (PIP &lt;= convertBPPressure)<br />
                                                    M = (a1 * (oilApi<sup>a2</sup>) + a3 * (convertBottomHoleTemp<sup>a4</sup>)) / (((a5 + 2 * (oilApi<sup>a6</sup>) / (PressureCalc<sup>a7</sup>))<sup>2</sup>))<br />
                                                    Rs = ((Pressure / a8) + a9) * (SGg<sup>a10</sup>) * (10<sup>M</sup>)<sup>a11</sup><br /><br />
                                                    else if (PIP &gt; convertBPPressure)<br />
                                                    M = (a1 * (oilApi<sup>a2</sup>) + a3 * (convertBottomHoleTemp<sup>a4</sup>)) / (((a5 + 2 * (oilApi<sup>a6</sup>) / (convertBPPressure<sup>a7</sup>))<sup>2</sup>))<br />
                                                    Rs = ((convertBPPressure / a8) + a9) * (SGg<sup>a10</sup>) * (10<sup>M</sup>)<sup>a11</sup><br /><br />
                                                    if (PIP &lt;= convertBPPressure)<br />
                                                    a1 = 2.510755E+00<br />
                                                    a2 = -4.852538E+00<br />
                                                    a3 = 1.183500E+01<br />
                                                    a4 = 1.365428E+05<br />
                                                    a5 = 2.252880E+00<br />
                                                    a6 = 1.007190E+01<br />
                                                    a7 = 4.450849E-01<br />
                                                    a8 = 5.352624E+00<br />
                                                    a9 = -6.309052E-01<br />
                                                    a10 = 9.000749E-01<br />
                                                    a11 = 9.871766E-01<br />
                                                    a12 = 7.865146E-04<br />
                                                    a13 = 2.689173E-06<br />
                                                    a14 = 1.100001E-05<br />
                                                    M = 0<br />
                                                    N1 = Rs<sup>a1</sup> * SGg<sup>a2</sup><br />
                                                    D1 = (Sgo<sup>a3</sup>) + a4 * ((convertBottomHoleTemp - 60)<sup>a5</sup>) + a6 * Rs<br />
                                                    N = N1 / D1<sup>a7</sup><br />
                                                    N2 = a8 + (2 * (Rs<sup>a9</sup>))<br />
                                                    D2 = SGg<sup>a10</sup> * (convertBottomHoleTemp - 60)<br />
                                                    D = N2 / D2<sup>2</sup><br />
                                                    M = N / D<br />
                                                    Bo = a11 + a12 * M + a13 * (M<sup>2</sup>) + a14 * (convertBottomHoleTemp - 60) * (oilApi / SGg)<br />
                                                    else if (PIP &gt; convertBPPressure)<br />
                                                    Bopb = 0<br />
                                                    M = (a1 * (oilApi<sup>a2</sup>) + a3 * (convertBottomHoleTemp<sup>a4</sup>)) / (Math.pow((a5 + 2 * Math.pow(oilApi, a6) / Math.pow(convertBPPressure, a7)), 2))<br />
                                                    Rspb = Math.pow(((convertBPPressure / a8) + a9) * Math.pow(SGg, a10) * Math.pow(10, M), a11)<br />
                                                    b1 = 2.510755E+00<br />
                                                    b2 = -4.852538E+00<br />
                                                    b3 = 1.183500E+01<br />
                                                    b4 = 1.365428E+05<br />
                                                    b5 = 2.252880E+00<br />
                                                    b6 = 1.007190E+01<br />
                                                    b7 = 4.450849E-01<br />
                                                    b8 = 5.352624E+00<br />
                                                    b9 = -6.309052E-01<br />
                                                    b10 = 9.000749E-01<br />
                                                    b11 = 9.871766E-01<br />
                                                    b12 = 7.865146E-04<br />
                                                    b13 = 2.689173E-06<br />
                                                    b14 = 1.100001E-05<br />
                                                    B = 0<br />
                                                    N1 = Math.pow(Rspb, b1) * Math.pow(SGg, b2)<br />
                                                    D1 = Math.pow(Sgo, b3) + b4 * Math.pow((convertBottomHoleTemp - 60), b5) + b6 * Rspb<br />
                                                    N = Math.pow(N1 / D1, b7)<br />
                                                    N2 = b8 + (2 * Math.pow(Rspb, b9))<br />
                                                    D2 = Math.pow(SGg, b10) * (convertBottomHoleTemp - 60)<br />
                                                    D = Math.pow(N2 / D2, 2)<br />
                                                    B = N / D<br />
                                                    Bopb = b11 + b12 * B + b13 * Math.pow(B, 2) + b14 * (convertBottomHoleTemp - 60) * (oilApi / SGg)<br />
                                                    Co = 1.705 * Math.pow(10, -7) * Math.pow(Rs, 0.69357) * Math.pow(SGg, 1.885) * Math.pow(Sgo, 0.3272) *
                                                    Math.pow(convertBottomHoleTemp, 0.6729) * Math.pow(PIP, -0.5906)<br />
                                                    Bo = Bopb * Math.exp((convertBPPressure - PIP) * Co)
                                                </p>
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal">Average composite SpGr</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                <b>
                                                    waterCalc + oilCalc
                                                </b>
                                                <p>
                                                    waterCalc = (WaterCut / 100) * SpGrWater
                                                    oilCalc = (OilCut / 100) * SpGrOil;<br />
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="align-center px-[24px] py-[16px] font-normal">Power factor (%)</th>
                                        <td className="align-center px-[24px] py-[16px]">
                                            <div>
                                                PowerCorrectionFactor = powercalc * SpecificGravity;
                                                <p><b>If (viscosity is greater than MaxViscosity)</b></p>
                                                <p className="pl-2">
                                                    powercalc = VP1 +VP2 * MaxViscosity + VP3 * (MaxViscosity^2) + VP4 *
                                                    (MaxViscosity^3);
                                                </p>
                                                <b> Else</b>
                                                <p className="pl-2">powercalc = VP1 + VP2 * viscosity + VP3 * (viscosity^2) + VP4 *
                                                    (viscosity^3);</p>
                                            </div>
                                            <div className="align-center">
                                                <p className="secondary"><b>if (viscosity is less than MinViscosity)
                                                </b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    powercalc = 1
                                                </p>
                                                <p className="secondary"><b>if (powercalc is greater than 1)
                                                </b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    PowerCorrectionFactor = SpecificGravity;
                                                </p>
                                                <p className="secondary">
                                                    <b>
                                                        else if (powercalc greater than or equal 0 & powercalc less than 0)
                                                    </b>
                                                </p>
                                                <p className="align-center pl-2 secondary-text">
                                                    PowerCorrectionFactor = powercalc * SpecificGravity;
                                                </p>
                                                <p className="secondary"><b>else</b></p>
                                                <p className="align-center pl-2 secondary-text">
                                                    PowerCorrectionFactor = 1;
                                                </p>
                                                <p className="secondary">
                                                    VP1,VP2,VP3,VP4,MinViscosity,MaxViscosity
                                                </p>
                                                <p className="secondary">
                                                    <b>ESPCatalog (DR_Pumps) in database</b>
                                                </p>
                                            </div>
                                        </td>
                                        <th className="align-center px-[24px] py-[16px] font-normal"></th>
                                    </tr>
                                </table>
                            </div>
                            <div className="align-center pad-all w-1/2 bg-darkcolor-700 border-[1px] rounded-[8px] border-darkcolor-400">
                                <table className="align-center w-full table table-striped table-bordered dtr-inline">
                                    <tr className="border-b-[1px] border-darkcolor-400 text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-semibold">Natural seperation efficiency</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">Efficiency</td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-semibold">Rs</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">Rs</td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-semibold">Bg</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">Bg</td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-semibold">Bo</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">Bo</td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-semibold">Volume of gas</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">GasVolume</td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-semibold">Volume of oil</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">Vo</td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-semibold">Volume of water</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">Vw</td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-semibold">Total fluid volume</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">Vt</td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-smeibold">Free gas / GVF</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">FreeGas</td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-semibold">GOR</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">GOR</td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-semibold">GLR</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">GLR</td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-semibold">Liquid phase density</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">PL</td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-semibold">Gas compressibility</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">GasComp</td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-semibold">Pressure</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">PIP</td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-semibold">Final composite SpGr</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">Final_Composite_SpGr</td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-semibold">Final flop</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">Flop</td>
                                    </tr>
                                    <tr className="text-neutral-25 text-[14px]">
                                        <th className="align-center px-[24px] py-[16px] font-normal col-1 font-semibold">Final temperature</th>
                                        <td className="align-center px-[24px] py-[16px] col-1 font-normal">BHT</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    }
                />
            </div>
        </>
    );
};

export default GasCalculations;
